// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.navbar-container[data-v-75cda836] {\n  z-index: 5;\n}\n.content[data-v-75cda836] {\n  margin-bottom: 70px;\n}\n", ""]);
// Exports
module.exports = exports;
